import { connect } from 'react-redux'

import FieldNewView from '../../components/FieldsComponents/FieldNewView'

const mapStateToProps = state => ({})

export default connect(mapStateToProps)(FieldNewView)
